import React from "react";
import { Head, Scheduler } from "../../components";
import "./exams.css";

export const Exams = () => {
  return (
    <>
      <div className="exams-g">
        <Head title="Examenes" />
        <Scheduler type="EXAM"/>
      </div>
    </>
  );
}

export default Exams;